import { api } from './api';
import { getTenant } from '../helpers';
import { callMainTenantAPIsOnly } from './helpers';

export const filterUserCredentials = (data)=>{
  const seen = new Set();
  return data.filter(item => {
    const duplicate = seen.has(item.entityId);
    seen.add(item.entityId);
    return !duplicate;
  });

}



const fetchUserCredentialsData = (tenantKey: string, username: string) => {
  return new Promise<any>((resolve, reject) => {
    api.iblaxdApiCallWrapper(
      (args) => api.iblaxdcredapi.credentialsOrgsUsersAssertionsRetrieve(...args),
      tenantKey,
      username,
      username
    )((err, data, response) => {

      if (response.status !== 200 || err) {
        console.error('getUserCredentialsAPI: ', err);
        reject(err);
      } else {
        resolve(response?.body[0]?.data || []);
      }
    });
  });
};


export function getUserCredentialsAPI(username: string, callback) {
  const tenant = getTenant();
  const shouldCallMainTenantOnly = callMainTenantAPIsOnly();

  fetchUserCredentialsData(tenant, username) .then(callback)
    .catch((error) => {
      console.error(error);
      callback([]);
    });

  // if (tenant === 'main' || shouldCallMainTenantOnly) {
  //   // Fetch user credentials data for the main tenant only
  //   fetchMainUserCredentials()
  //     .then(callback)
  //     .catch((error) => {
  //       console.error(error);
  //       callback(null);
  //     });
  // } else {
  //   // Fetch user credentials data for both the current tenant and the main tenant
  //   Promise.all([
  //     fetchUserCredentialsData(tenant, username).catch((error) => {
  //       console.error(error);
  //       return null; // Return null in case of error for main tenant
  //     }),
  //     fetchMainUserCredentials().catch((error) => {
  //       console.error(error);
  //       return null; // Return null in case of error for main tenant
  //     }),
  //   ])
  //     .then((results) => {
  //       // Filter out any errors and aggregate results
  //       const validResults = results.filter(result => result !== null);
  //       // Aggregate the results, assuming we just need to combine the arrays
  //       const aggregatedData = validResults.flat();
  //       callback(filterUserCredentials(aggregatedData));
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //       callback(null);
  //     });
  // }
}


const fetchDiscoverCredentialsData = (tenantKey: string, username: string) => {
  return new Promise<any>((resolve, reject) => {
    api.iblaxdApiCallWrapper(
      (args) => api.iblaxdcredapi.credentialsOrgsUsersRetrieve(...args),
      tenantKey,
      username
    )((err, data, response) => {
      if (response.status !== 200 || err) {
        console.error('getDiscoverCredentialsAPI: ', err);
        reject(err);
      } else {
        resolve(response?.body?.result?.data || []);
      }
    });
  });
};



export function getDiscoverCredentialsAPI(username: string, callback) {
  const tenant = getTenant();
  const shouldCallMainTenantOnly = callMainTenantAPIsOnly();

  fetchDiscoverCredentialsData(tenant, username) .then(callback)
    .catch((error) => {
      console.error(error);
      callback([]);
    });

  // if (tenant === 'main' || shouldCallMainTenantOnly) {
  //   // Fetch discover credentials data for the main tenant only
  //   fetchMainDiscoverCredentials()
  //     .then(callback)
  //     .catch((error) => {
  //       console.error(error);
  //       callback(null);
  //     });
  // } else {
  //   // Fetch discover credentials data for both the current tenant and the main tenant
  //   Promise.all([
  //     fetchDiscoverCredentialsData(tenant, username).catch((error) => {
  //       console.error(error);
  //       return null; // Return null in case of error for main tenant
  //     }),
  //     fetchMainDiscoverCredentials().catch((error) => {
  //       console.error(error);
  //       return null; // Return null in case of error for main tenant
  //     }),
  //   ])
  //     .then((results) => {
  //       // Filter out any errors and aggregate results
  //       const validResults = results.filter(result => result !== null);
  //       // Aggregate the results, assuming we just need to combine the arrays
  //       const aggregatedData = validResults.flat();
  //       callback(filterUserCredentials(aggregatedData));
  //     })
  //     .catch((error) => {
  //       console.error(error);
  //       callback(null);
  //     });
  // }
}

